import { render, staticRenderFns } from "./noticeListNew.vue?vue&type=template&id=3cce38a6&scoped=true"
import script from "./noticeListNew.vue?vue&type=script&lang=js"
export * from "./noticeListNew.vue?vue&type=script&lang=js"
import style0 from "./noticeListNew.vue?vue&type=style&index=0&id=3cce38a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cce38a6",
  null
  
)

export default component.exports